var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileReceipts = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 11h4m-4 3h6m-1.645 7.374a1.764 1.764 0 0 1-2.71 0 1.764 1.764 0 0 0-2.503-.21l-.683.585A.884.884 0 0 1 8 21.08V9a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12.078a.884.884 0 0 1-1.459.672l-.683-.586a1.764 1.764 0 0 0-2.503.21Z",
  stroke: "#231F20",
  strokeWidth: 1.286,
  strokeLinecap: "round"
})));
export default SvgProfileReceipts;